module.exports = __webpack_public_path__ + "img/hp-v1.16293b1f.svg";